import { BASE_URL } from "../../../envs"
import { CustomField } from "../../../types/custom-fields/custom-field"
import { HttpClient } from "../http-client"

export class FieldsClient {

  private readonly httpClient

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async get(): Promise<CustomField[]> {
    const response = await this.httpClient.fetch(`${BASE_URL}/fields`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`Error while fields: ${response.status}`)
    }
    return await response.json()
  }
}
